import { useSelector } from "react-redux";


const selectDemoMode = (state) => state.ui.demoMode;

export function useIsDemoMode() {
    return useSelector(selectDemoMode);
}